import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {classMap} from 'lit/directives/class-map.js';
import {when} from 'lit/directives/when.js';
import {connect} from 'pwa-helpers';
import {property} from 'lit/decorators/property.js';

import store from '../../store';
import {staggeredReveal} from '../../css/styleSets';
import {setIomoCustomColorMaterial} from '../iomoSlice';
import {selectIomoCustomColor} from '../iomoSelectors';

@customElement('custom-color-select-item')
export class CustomColorSelectItem extends connect(store)(LitElement) {

	@property({type: Object})
	option = {};

	@property({type: String})
	type = '';

	static styles = [
		staggeredReveal,
		css`
			:host {
				flex-grow: 1;
				animation-name: fade;
			}

			.item {
				display: flex;
				flex-direction: row;
				position: relative;
				margin-bottom: 0;
				width: 100%;
				box-shadow: 1px 0 0 0 var(--color-widget-border),
				0 1px 0 0 var(--color-widget-border),
				1px 1px 0 0 var(--color-widget-border),
				1px 0 0 0 var(--color-widget-border) inset,
				0 1px 0 0 var(--color-widget-border) inset;
			}
			.item button {
				display: flex;
				flex-direction: row;
				width: 100%;
				font: var(--font-widget-label);
				color: var(--color-widget-text);
				background-color: transparent;
				text-align: left;
				height: 48px;
				padding: 0;
				cursor: pointer;
				white-space: nowrap;
				transition: background-color 0.4s, color 0.4s;
				border: 0 none;
			}
			.item button.swappable {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 48px;
				height: 48px;
			}
			.item button.hidden {
				display: none;
			}
			button:hover {
				background-color: var(--color-widget-background-hover);
			}

			.selected button {
				background-color: var(--color-widget-background-selected);
			}

			.fixed button {
				pointer-events: none;
			}

			.disabled button {
				color: var(--color-widget-border);
				pointer-events: none;
			}

			.disabled button:hover {
				color: var(--color-widget-border);
			}

			.disabled.selected button {
				background-color: var(--color-widget-background-selected);
				color: var(--color-widget-background);
			}



			.thumbnail {
				display: flex;
				flex-direction: row;
				background: #f1cba0;
				width: 48px;
				height: 48px;
				aspect-ratio: 1;
				flex-basis: 48px;
				box-shadow: 1px 0 0 0 var(--color-widget-border),
				0 1px 0 0 var(--color-widget-border),
				1px 1px 0 0 var(--color-widget-border),
				1px 0 0 0 var(--color-widget-border) inset,
				0 1px 0 0 var(--color-widget-border) inset;
			}
			.label {
				color: var(--color-widget-text);
				font: var(--font-widget-info);
				flex-basis: 100%;
				align-content: center;
				padding: 0 var(--very-small-padding);
			}
		`];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.lang = state.status.lang;
		this.customColor = selectIomoCustomColor(state);
	}

	isSelected() {
		return this.customColor[this.type].material === this.option.id;
	}

	isExcluded() {
		return false;
	}

	isDisabeled() {
		return !this.canBeSelected;
	}

	canBeExcluded() {
		return true;
	}
	canBeSelected() {
		return true;
	}

	async setOption() {
		store.dispatch(setIomoCustomColorMaterial({type: this.type, material: this.option.id}));
	}
	render() {
		return html`
			<div class="item ${classMap({selected: this.isSelected(), disabled: this.isDisabeled(), fixed: !this.canBeExcluded()})}">
				<button @click="${this.setOption}">
					<div class="thumbnail" style="background-color: ${this.option.color};"></div>
					<div class="label">${this.option.label[this.lang]}</div>
				</button>
			</div>
		`;
	}
}
